/** One TPN line as GIR needs it: the infusion rate and the glucose it carries. */
export interface GirLine {
    /** ml/hour */
    rate: number;
    /** grams of glucose per ml, as the formula config holds it — a D10 solution is 0.1 */
    glucosePerMl: number;
}

/** Shown under the GIR on combined feeding: enteral glucose is not part of it. */
export const GIR_TPN_ONLY_NOTE = 'ה-GIR מחושב רק לפי הזנת TPN';

/**
 * Glucose Infusion Rate, in mg/kg/min, summed over every TPN line.
 *
 * Per line this is the bedside formula  rate (ml/hr) × dextrose (%) ÷ (6 × kg).
 * The dextrose goes in as a **percentage**: 0.1 g/ml is 10%, not 0.1 — so a
 * 6 kg baby on 25 ml/hr of a 0.1 g/ml solution is 25 × 10 ÷ 36 = 6.94.
 * It is the rate *while the line runs*, so a line given for fewer than 24 hours
 * is not averaged down over the day.
 */
export const calculateGir = (lines: GirLine[], weightKg: number): number => {
    if (!(weightKg > 0)) return 0;
    const numerator = lines.reduce((sum, { rate, glucosePerMl }) => {
        if (!(rate > 0) || !(glucosePerMl > 0)) return sum;
        const dextrosePercent = glucosePerMl * 100;
        return sum + rate * dextrosePercent;
    }, 0);
    return numerator / (6 * weightKg);
};
